import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { UnitMapper } from '../../ninthAge/UnitMapper';
import { army_list_unit_option_formated } from '@Api';
import { ArmyListUnitOptionFormated, ArmyListUnitOption } from '@Models';

@injectable()
export class ArmyListUnitOptionFormatedMapper {
  @inject(TYPES.UnitMapper) private _unitMapper!: UnitMapper;

  public map(item: army_list_unit_option_formated): ArmyListUnitOptionFormated {
    return {
      entry: item.entry,
      name: item.name,
      fixed: item.fixed ?? '',
      unit: item.unit != null ? this._unitMapper.mapAll(item.unit) : null,
      quantity: item.quantity ?? 1,
      total: item.total ?? 0,
      isSub: item.is_sub,
      options: item.options?.map((o) => this.map(o)),
      unitOptionId: item.option?.id ?? null,
    } satisfies ArmyListUnitOptionFormated as ArmyListUnitOptionFormated;
  }

  public mapToBuilder(item: ArmyListUnitOptionFormated): ArmyListUnitOption[] {
    const option: ArmyListUnitOption[] = [
      {
        id: '',
        name: item.name ?? '',
        quantity: item.quantity,
        points: item.total,
        unit_option_id: item.unitOptionId!!,
        isDeleted: false,
      } satisfies ArmyListUnitOption as ArmyListUnitOption,
    ];

    item.options.map((o) => {
      const subOption = this.mapToBuilder(o);
      option.push(...subOption);
    });

    return option;
  }
}
